// extracted by mini-css-extract-plugin
module.exports = {"grid1":"fs_grid1__17hz6","previewCard":"fs_previewCard__1EmIo","labelc1":"fs_labelc1__1sgFo","previewHead":"fs_previewHead__LbgTW"};